import { netNoticeList } from '@/api';
import { onMounted, ref } from 'vue';
export default {
  name: 'NetNotice',

  setup() {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';
    const list = ref([]);
    const loading = ref(true);
    const finished = ref(false);
    const param = ref({
      pageNo: 1,
      pageSize: 20
    });
    onMounted(() => {
      refresh();
    });

    const refresh = () => {
      param.value.pageNo = 1;
      loading.value = true;
      netNoticeList(param.value).then(res => {
        if (res.code === 0) {
          list.value = res.data.list;

          if (res.data.list.length < res.data.pageSize) {
            finished.value = true;
          }
        }
      }).finally(() => loading.value = false);
    };

    const load = () => {
      loading.value = true;
      param.value.pageNo++;
      netNoticeList(param.value).then(res => {
        if (res.code === 0) {
          list.value = [...list.value, ...res.data.list];

          if (res.data.list.length < res.data.pageSize) {
            finished.value = true;
          }
        }
      }).finally(() => loading.value = false);
    };

    const curentTime = time => {
      const date = new Date(time);
      const year = date.getFullYear(); //年

      const month = date.getMonth() + 1; //月

      const day = date.getDate(); //日
      // var hh = now.getHours();            //时
      // var mm = now.getMinutes();          //分
      //
      // var clock = year + "-";
      //
      // if(month < 10)
      //   clock += "0";
      //
      // clock += month + "-";
      //
      // if(day < 10)
      //   clock += "0";
      //
      // clock += day + " ";
      //
      // if(hh < 10)
      //   clock += "0";
      //
      // clock += hh + ":";
      // if (mm < 10) clock += '0';
      // clock += mm;

      return year + '年' + month + '月' + day + '日';
    };

    return {
      list,
      loading,
      refresh,
      finished,
      load,
      curentTime
    };
  }

};